import { Site } from 'types/site';

const getSiteNameBySiteID = (siteID?: any, sites?: Site[]) => {
  let siteNameById = '';
  if (!Boolean(siteID)) return (siteNameById = ' - ');

  const site = sites?.find((site) => site._id === siteID);
  siteNameById = site?.name || ' - ';
  return siteNameById;
};

export default getSiteNameBySiteID;
